import jrMySearchesStatementTemplate from '../../view/angular/pages/my-searches-statement.tpl.html';
import { JtagService } from '../../ts/service/jtag-service.ts';
import { MySearchesResourceService } from '../../ts/service/my-searches-resource-service.ts';

angular
  .module('jrMySearches', ['jrConfig'])
  .value('jrMySearchesStatementTemplate', jrMySearchesStatementTemplate)
  .controller('MySearchesCtrl', [
    'SearchDistanceConfig',
    'SearchOptionsService',
    'MySearchesConfig',
    'MySearchesService',
    '$scope',
    'Messages',
    function (
      SearchDistanceConfig,
      SearchOptionsService,
      MySearchesConfig,
      MySearchesService,
      $scope,
      Messages
    ) {
      $scope.messages = Messages;
      $scope.autoDistanceText = SearchDistanceConfig.autoDistanceText;
      $scope.distanceFilterEnabled = SearchDistanceConfig.enabled;
      $scope.addStatementOpened = false;
      $scope.statementError = false;
      $scope.hasStatements = function () {
        return $scope.statements.length > 0;
      };
      $scope.openAddStatement = function () {
        $scope.addStatementOpened = !$scope.addStatementOpened;
        $scope.statementError = false;
      };
      $scope.addNewStatement = function (event, statement) {
        MySearchesResourceService.addStatement(statement).then(function (response) {
          const result = response.json();
          if (result !== 'false') {
            const { what, where, radiusValue: radius } = result;
            JtagService.trackMySearches('add', { what, where, radius });
            MySearchesService.addStatement(MySearchesService.decorateStatementWithDistance(result));
            $scope.addStatementOpened = false;
            $scope.newStatement = {
              what: '',
              where: '',
              distance: SearchOptionsService.findDistance(),
              distances: SearchOptionsService.distances,
            };
          } else {
            $scope.statementError = true;
          }
          $scope.$digest();
        });
        event.preventDefault();
      };
      $scope.newStatement = {
        what: '',
        where: '',
        distance: SearchOptionsService.findDistance(),
        distances: SearchOptionsService.distances,
      };

      $scope.$watch(
        function () {
          return MySearchesService.statements;
        },
        function (statements) {
          $scope.statements = angular.copy(statements);
          $scope.canAddStatement = $scope.statements.length < MySearchesConfig.maxUserStatements;
        },
        true
      );
    },
  ])
  .directive('jrMySearchesStatement', [
    'MySearchesService',
    'SearchDistanceConfig',
    'jrMySearchesStatementTemplate',
    function (MySearchesService, SearchDistanceConfig, jrMySearchesStatementTemplate) {
      return {
        scope: true,
        restrict: 'AE',
        replace: true,
        template: jrMySearchesStatementTemplate,
        link(scope, element, attrs) {
          scope.isNew = scope.$eval(attrs.isNew) || false;
          scope.isEditing = scope.isNew;
          scope.statementError = false;
          scope.showDistanceInLocation = SearchDistanceConfig.enabled && jrConfigGlobal.isMobile;
          scope.deleteConfirmationVisible = false;
          function isStatementsEqual(newStatement, oldStatement) {
            return (
              newStatement.what === oldStatement.what &&
              newStatement.where === oldStatement.where &&
              newStatement.radiusValue === oldStatement.radiusValue
            );
          }

          scope.addStatement = function (event) {
            event.preventDefault();

            MySearchesResourceService.addStatement(scope.statement).then(function (response) {
              const result = response.json();
              MySearchesService.addStatement(
                MySearchesService.decorateStatementWithDistance(result)
              );
              scope.$digest();
            });
          };
          scope.editStatement = function (event) {
            scope.initialStatement = angular.copy(scope.statement);
            scope.isEditing = true;
            scope.focusInput = true;
            scope.statementError = false;
            event.preventDefault();
          };
          scope.resetStatement = function (event) {
            scope.statement = scope.initialStatement;
            scope.isEditing = false;
            event.preventDefault();
          };
          scope.saveStatement = function (event, index) {
            event.preventDefault();

            if (scope.statement.what === '' && scope.statement.where === '') {
              scope.statementError = true;
              event.preventDefault();
              return;
            }
            MySearchesResourceService.saveStatement(scope.statement, index).then(function (
              response
            ) {
              const oldStatement = MySearchesService.statements[index];
              const newStatement = response.json();

              if (!isStatementsEqual(newStatement, oldStatement)) {
                const { what: newWhat, where: newWhere, radiusValue: newRadius } = newStatement;
                const { what: oldWhat, where: oldWhere, radiusValue: oldRadius } = oldStatement;
                JtagService.trackMySearches('add', {
                  what: newWhat,
                  where: newWhere,
                  radius: newRadius,
                });
                JtagService.trackMySearches('delete', {
                  what: oldWhat,
                  where: oldWhere,
                  radius: oldRadius,
                });
                MySearchesService.saveStatement(
                  MySearchesService.decorateStatementWithDistance(newStatement),
                  index
                );
                scope.$digest();
              }
            });
          };
          scope.deleteStatement = function (event, index, redirect) {
            event.preventDefault();
            MySearchesResourceService.deleteStatement(index).then(function (response) {
              const statement = MySearchesService.statements[index];
              const { what: oldWhat, where: oldWhere, radiusValue: oldRadius } = statement;
              JtagService.trackMySearches('delete', {
                what: oldWhat,
                where: oldWhere,
                radius: oldRadius,
              });
              if (redirect === true) {
                location.href = event.target.parentElement.href;
              } else {
                MySearchesService.deleteStatement(index);
              }
              scope.$digest();
            });
          };
        },
      };
    },
  ])
  .directive('jrFocusInput', [
    '$timeout',
    function ($timeout) {
      return {
        scope: { trigger: '=jrFocusInput' },
        link(scope, element) {
          scope.$watch('trigger', function (value) {
            if (value) {
              element[0].focus();
              scope.trigger = false;
            }
          });
        },
      };
    },
  ]);
